import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    position: relative; 
    overflow: hidden;   
    color: #fff;
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        padding: 0 20px;
    }
`

export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 30px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        flex-direction: column;
    }
`
export const TitleWrap = styled.div`
    width: 66.66666667%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 100px 0;
    position: relative;
    transition: 0.2s;
    &::after{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: white;
        bottom: 40px;
        left: 0px;
        transition: 0.2s;
    }
    @media screen and (max-width: 767px){
        width: 100%;
        &::after{
            left: 50%;
            transform: translateX(-50%);
        }
    }
`
export const Title = styled.h1`
    font-size: 40px;
    text-align: left;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 5px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        text-align: center;

    }
`
export const SubTitle = styled.p`
    line-height: 32px;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 1px;
    @media screen and (max-width: 767px){
        text-align: center;

    }
`
export const StatsWrap = styled.div`
    width: 33.33333333%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    //padding-top: 40px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        width: 100%;
        padding: 0 0 40px;
    }
`
export const Stat = styled.p`
    font-size: 17px;
    line-height: 1.66em;
    text-align: right;
`
